export const HOST = process.env.NEXT_PUBLIC_HOST
export const NODE_ENV = process.env.NODE_ENV
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH

export const API_URL = process.env.NEXT_PUBLIC_API_URL
export const API_URL_MAIN_SITE = process.env.NEXT_PUBLIC_MAIN_SITE_API_URL

export const isDevEnv = NODE_ENV === 'development'
export const isProdEnv = NODE_ENV === 'production'
